module.exports = "<div class=\"pageContent paddingLight classicArea withNav\">\n  <navbar></navbar>\n  <rlink-apps-status></rlink-apps-status>\n  <carousel></carousel>\n  <div class=\"limitContent\">\n    <section class=\"choiceApp\">\n      <h2>{{ 'catalog.newAppWish' | translate }}</h2>\n      <div class=\"tabAppCarto\">\n        <ui-view />\n      </div>\n    </section>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/vehicle/catalog/catalog.html
// module id = 1059
// module chunks = 0